import { addAttachmentTask, addCategory, addFolder, addList, getProjectDetailTM, getListTM, getTreeTM, getTaskDetailTM, getTaskDetailKorespondensiTM, addTask, updateStatusTask, addCommentTask, getDashboardTM, getDashboardCountTM, putCategory, putList, putTask, deleteList, deleteCategory, getProjectChoiceTM, deleteTaskTM, getMonitoringTM, getKorespondensiTM, updateStatusKorespondensi } from '@crema/services/apis/taskmanagement';
import { appIntl } from '@crema/utility/helper/Utils';
import {
    GET_TAB_VALUE_HEADER,
    FETCH_ERROR,
    FETCH_SUCCESS,
    FETCH_START,
    GET_TREE_TM,
    ADD_CATEGORY,
    ADD_FOLDER,
    ADD_LIST,
    SHOW_MESSAGE,
    GET_LIST_TM,
    ADD_ATTACHMENT_TM,
    DELETE_ATTACHMENT_TM,
    DELETE_ALL_ATTACHMENT_TM,
    GET_PROJECT_DETAIL_TM,
    GET_TASK_DETAIL_TM,
    ADD_TASK,
    UPDATE_STATUS_TASK,
    ADD_COMMENT_TM,
    GET_DASHBOARD_COUNT_TM,
    PUT_CATEGORY,
    PUT_LIST,
    PUT_TASK,
    DELETE_LIST,
    DELETE_CATEGORY,
    GET_PROJECT_CHOICE_TM,
    DELETE_TASK_TM,
    GET_MONITORING_TM,
    GET_ACTION_TASK,
    DELETE_LIST_TM
} from 'shared/constants/ActionTypes';

export const setTabValueHeader = (tabValue) => {
    return (dispatch) => dispatch({ type: GET_TAB_VALUE_HEADER, payload: tabValue });
};

export const setActionTask = (action) => {
    return (dispatch) => dispatch({ type: GET_ACTION_TASK, payload: action });
};

export const onGetTreeTM = (sort) => {
    const messages = appIntl();
    return (dispatch) => {
        // dispatch({ type: FETCH_START });
        getTreeTM(sort)
            .then(data => {
                if (data.success) {
                    const arr = data.result;
                    arr?.map(project => {
                        project['children'] = project['list_tasks']
                        project['type'] = 'category'

                        delete project['list_tasks']

                        project.children.map(list => {
                            list['type'] = 'list'
                        })
                    });

                    const newArr = [
                        {
                            id: '3',
                            name: 'Agenda Rapat',
                            children: [],
                            type: 'folder',
                            kategori: 'event'
                        },
                        {
                            id: '2',
                            name: 'Task Untuk Saya',
                            children: [],
                            type: 'folder',
                            kategori: 'task_saya'
                        },
                        {
                            id: '5',
                            name: 'Task Dari Saya',
                            children: [],
                            type: 'folder',
                            kategori: 'task'
                        },
                    ]
                    arr?.map(item => {
                        if (item.kategori === 'event') {
                            item.children?.map(child => {
                                child['kategori'] = 'event'
                            })
                            newArr[0].children.push(item)
                        } else if (item.kategori === 'task') {
                            if (item.my_project) {
                                item.children?.map(child => {
                                    child['kategori'] = 'task'
                                })
                                newArr[2].children.push(item)
                            } else {
                                item['kategori'] = 'task_saya'
                                item.children?.map(child => {
                                    child['kategori'] = 'task_saya'
                                })
                                newArr[1].children.push(item)
                            }
                        } else if (item.kategori === null) {
                            newArr.push(item)
                        }
                    })

                    dispatch({ type: GET_TREE_TM, payload: newArr })
                    // dispatch({ type: FETCH_SUCCESS })

                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch(error => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
};

export const onGetListTM = (id_list, type) => {
    const messages = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        getListTM(id_list)
            .then(data => {
                if (data) {
                    const newDataList = {
                        id: data.result.id,
                        name: data.result.name,
                        project_pic: data.result.project_pic,
                        project_creator: data.result.project_creator,
                        type: type,
                        list: [
                            {
                                id: 1,
                                title: 'Backlog',
                                cards: []
                            },
                            {
                                id: 2,
                                title: 'In Progress',
                                cards: []
                            },
                            {
                                id: 3,
                                title: 'Pending',
                                cards: []
                            },
                            {
                                id: 4,
                                title: 'Completed',
                                cards: []
                            },
                        ]
                    }

                    data.result?.tasks?.map(task => {
                        if (task.status === 'backlog') {
                            newDataList.list[0].cards.push(task)
                        } else if (task.status === 'in progress') {
                            newDataList.list[1].cards.push(task)
                        } else if (task.status === 'pending') {
                            newDataList.list[2].cards.push(task)
                        } else if (task.status === 'completed') {
                            newDataList.list[3].cards.push(task)
                        }
                    })

                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: GET_LIST_TM, payload: newDataList })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch(error => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
};

export const onGetListDashboardTM = (id_project, status, name, my_task) => {
    const messages = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        const newDataList = {
            id: 'dashboard',
            name: name,
            list: [
                {
                    id: 1,
                    title: 'Today',
                    cards: []
                },
                {
                    id: 2,
                    title: 'This Week',
                    cards: []
                },
                {
                    id: 3,
                    title: 'Overdue',
                    cards: []
                },
                {
                    id: 4,
                    title: 'Complete',
                    cards: []
                },
            ]
        }
        getDashboardTM(id_project, status, my_task)
            .then(data => {
                if (data) {
                    let i = 0
                    data.result?.map(item => {
                        if (item.deadline_status === 'today') {
                            newDataList.list[0].cards.push(item)
                        } else if (item.deadline_status === 'this week') {
                            newDataList.list[1].cards.push(item)
                        } else if (item.deadline_status === 'overdue') {
                            newDataList.list[2].cards.push(item)
                        } else if (item.deadline_status === 'completed') {
                            newDataList.list[3].cards.push(item)
                        }
                        i = i + 1
                    })

                    dispatch({ type: GET_LIST_TM, payload: newDataList })
                    if (i === data.result.length) {
                        dispatch({ type: FETCH_SUCCESS })
                    }
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch(error => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
};

export const onGetDashboardCountTM = (id_project, my_task) => {
    const messages = appIntl();
    return (dispatch) => {
        // dispatch({ type: FETCH_START });
        getDashboardCountTM(id_project, my_task)
            .then(data => {
                if (data.success) {
                    // dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: GET_DASHBOARD_COUNT_TM, payload: data.result })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch(error => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
};

export const onGetListKorespondensiTM = (status) => {
    const messages = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        const newDataList = {
            id: 'korespondensi',
            name: 'Korespondensi',
            list: []
        }
        getKorespondensiTM(status)
            .then(data => {
                if (data) {
                    let i = 0
                    data.results.map(item => {
                        item?.children?.map(child => {
                            newDataList.list.push(child)
                        })
                        i = i + 1
                    })

                    dispatch({ type: GET_LIST_TM, payload: newDataList })
                    if (i === data.results.length) {
                        dispatch({ type: FETCH_SUCCESS })
                    }
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch(error => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
};

export const onDeleteListTM = () => {
    return (dispatch) => {
        dispatch({ type: DELETE_LIST_TM })
    }
};

export const onGetMonitoringTM = (project_id, search) => {
    const messages = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        getMonitoringTM(project_id, search)
            .then(data => {
                if (data) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: GET_MONITORING_TM, payload: data })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch(error => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
};


export const onGetProjectChoiceTM = () => {
    const messages = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        getProjectChoiceTM()
            .then(data => {
                if (data) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: GET_PROJECT_CHOICE_TM, payload: data.results })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch(error => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
};

export const onAddCategory = (dataCategory, treeView) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        addCategory(dataCategory)
            .then((data) => {
                if (data.success) {
                    const newCategory = data.result
                    newCategory['type'] = 'category'
                    newCategory['kategori'] = 'task'
                    newCategory['children'] = []

                    treeView[2].children.push(newCategory)

                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: ADD_CATEGORY, payload: treeView })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Project Berhasil Ditambahkan' })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onPutCategory = (dataCategory, id_project, treeView, list) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        putCategory(dataCategory, id_project)
            .then((data) => {
                if (data.success) {
                    treeView?.map((folder, i) => {
                        folder?.children?.map((item, j) => {
                            if (item.id === id_project) {
                                treeView[i].children[j].name = data.result.name
                            }
                        })
                    })

                    list.name = data.result.name
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: PUT_CATEGORY, payload: { treeView: treeView, data: data.result, list: list } })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Project Berhasil Diubah' })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onDeleteProject = (id_project, dataTree) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        deleteCategory(id_project)
            .then((data) => {
                if (data.success) {
                    dataTree?.map((folder, i) => {
                        folder?.children?.map((project, j) => {
                            if (project.id === id_project) {
                                dataTree[i].children.splice(j, 1)
                            }
                        })
                    })
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: DELETE_CATEGORY, payload: dataTree })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Project Berhasil Dihapus' })
                }
                else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onAddFolder = (dataFolder, dataTree) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        addFolder(dataFolder)
            .then((data) => {
                if (data.success) {
                    const newFolder = data.result
                    newFolder['type'] = 'folder'

                    const newTreeView = dataTree?.map(folder => {
                        const dataFolder = folder?.children?.map(project => {
                            if (project.id === dataFolder.project_id) {
                                project['children'] = [
                                    ...project['children'],
                                    newFolder
                                ]
                            }
                            return project
                        })
                        return dataFolder
                    })

                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: ADD_FOLDER, payload: newTreeView })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Folder Berhasil Ditambahkan' })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onAddList = (dataList, dataTree) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        addList(dataList)
            .then((data) => {
                if (data.success) {
                    const newList = data.result
                    newList['type'] = 'list'

                    const newTreeView = []
                    dataTree?.map(folder => {
                        folder?.children?.map(project => {
                            if (project.id === dataList.project_id) {
                                project['children'] = [
                                    ...project['children'],
                                    {
                                        id: newList.id,
                                        name: newList.name,
                                        type: 'list',
                                        kategori: 'task'
                                    }
                                ]
                            }
                        })
                        newTreeView.push(folder)
                    })

                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: ADD_LIST, payload: newTreeView })
                    dispatch({ type: SHOW_MESSAGE, payload: 'List Berhasil Ditambahkan' })
                }
                else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onPutList = (dataList, dataTree, id_list, list) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        putList(dataList, id_list)
            .then((data) => {
                if (data.success) {
                    dataTree?.map((folder, i) => {
                        folder?.children?.map((project, j) => {
                            project.children?.map((list, k) => {
                                if (list.id === id_list) {
                                    dataTree[i].children[j].children[k].name = data.result.name
                                }
                            })
                        })
                    })

                    list.name = data.result.name

                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: PUT_LIST, payload: { tree: dataTree, list: list } })
                    dispatch({ type: SHOW_MESSAGE, payload: 'List Berhasil Diubah' })
                }
                else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onDeleteList = (id_list, dataTree) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        deleteList(id_list)
            .then((data) => {
                if (data.success) {

                    dataTree?.map((folder, i) => {
                        folder?.children?.map((project, j) => {
                            project.children?.map((list, k) => {
                                if (list.id === id_list) {
                                    dataTree[i].children[j].children.splice(k, 1)
                                }
                            })
                        })
                    })
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: DELETE_LIST, payload: dataTree })
                    dispatch({ type: SHOW_MESSAGE, payload: 'List Berhasil Dihapus' })
                }
                else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onAddAttachmentTask = (type, file) => {
    const { messages } = appIntl();
    return (dispatch) => {
        if (type === 'onDrop') {
            dispatch({ type: FETCH_START });
            addAttachmentTask(file)
                .then((data) => {
                    if (data.success) {
                        dispatch({ type: FETCH_SUCCESS })
                        dispatch({ type: ADD_ATTACHMENT_TM, payload: data.result })
                        dispatch({ type: SHOW_MESSAGE, payload: 'Lampiran Berhasil Ditambahkan' })
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: messages['message.somethingWentWrong'],
                        });
                    }
                })
                .catch((error) => {
                    dispatch({ type: FETCH_ERROR, payload: 'Ukuran File Lampiran Terlalu Besar ' + error });
                })
        } else {
            dispatch({ type: ADD_ATTACHMENT_TM, payload: file })
        }
    };
}

export const onDeleteAttachmentTask = (data) => {
    return (dispatch) => dispatch({ type: DELETE_ATTACHMENT_TM, payload: data });
};

export const onDeleteAllAttachmentTask = () => {
    return (dispatch) => dispatch({ type: DELETE_ALL_ATTACHMENT_TM });
};

export const onGetProjectDetailTM = (id_project, list, type = 'task') => {
    const messages = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        getProjectDetailTM(id_project)
            .then(data => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: GET_PROJECT_DETAIL_TM, payload: data.result })
                    const newDataList = {
                        ...list,
                        id: type === 'project' ? id_project : list.id,
                        name: type === 'project' ? data.result.name : list.name,
                        list: type === 'project' ? [] : list.list,
                    }
                    dispatch({ type: GET_LIST_TM, payload: newDataList })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch(error => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
};

export const onGetTaskDetailTM = (id_task, type = 'task') => {
    const messages = appIntl();
    return (dispatch) => {
        if (type === 'task') {
            dispatch({ type: FETCH_START });
            getTaskDetailTM(id_task)
                .then(data => {
                    if (data) {
                        dispatch({ type: FETCH_SUCCESS })
                        dispatch({ type: GET_TASK_DETAIL_TM, payload: data.result })
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: messages['message.somethingWentWrong'],
                        });
                    }
                })
                .catch(error => {
                    dispatch({ type: FETCH_ERROR, payload: error.message });
                })
        } else if (type === 'korespondensi') {
            dispatch({ type: FETCH_START });
            getTaskDetailKorespondensiTM(id_task)
                .then(data => {
                    if (data) {
                        dispatch({ type: FETCH_SUCCESS })
                        dispatch({ type: GET_TASK_DETAIL_TM, payload: data.results })
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: messages['message.somethingWentWrong'],
                        });
                    }
                })
                .catch(error => {
                    dispatch({ type: FETCH_ERROR, payload: error.message });
                })
        } else {
            // dispatch({ type: FETCH_SUCCESS })
            dispatch({ type: GET_TASK_DETAIL_TM, payload: null })
        }
    }
};

export const onAddTask = (dataTask, list) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        addTask(dataTask)
            .then((data) => {
                if (data.success) {
                    const newList = {
                        ...list
                    }
                    if (dataTask.status === '') {
                        newList.list[0].cards.push({
                            ...data.result,
                            laneId: 1
                        })
                    } else {
                        if (dataTask.status === 'backlog') {
                            newList.list[0].cards.push({
                                ...data.result,
                                laneId: 1
                            })
                        } else if (dataTask.status === 'in progress') {
                            newList.list[1].cards.push({
                                ...data.result,
                                laneId: 2
                            })
                        } else if (dataTask.status === 'pending') {
                            newList.list[2].cards.push({
                                ...data.result,
                                laneId: 3
                            })
                        } else if (dataTask.status === 'completed') {
                            newList.list[3].cards.push({
                                ...data.result,
                                laneId: 4
                            })
                        }
                    }
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: ADD_TASK, payload: newList })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Tugas Berhasil Ditambahkan' })
                    dispatch({ type: GET_ACTION_TASK, payload: true })
                }
                else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onPutTask = (dataTask, id_task, list) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        putTask(dataTask, id_task)
            .then((data) => {
                if (data.success) {
                    const newList = {
                        ...list
                    }
                    newList.list?.map(item => {
                        item.cards?.map((card, index) => {
                            if (card.id === id_task) {
                                item.cards.splice(index, 1)
                            }
                        })
                    })
                    if (dataTask.status === '') {
                        newList.list[0].cards.push({
                            ...data.result,
                            laneId: 1
                        })
                    } else {
                        if (dataTask.status === 'backlog') {
                            newList.list[0].cards.push({
                                ...data.result,
                                laneId: 1
                            })
                        } else if (dataTask.status === 'in progress') {
                            newList.list[1].cards.push({
                                ...data.result,
                                laneId: 2
                            })
                        } else if (dataTask.status === 'pending') {
                            newList.list[2].cards.push({
                                ...data.result,
                                laneId: 3
                            })
                        } else if (dataTask.status === 'completed') {
                            newList.list[3].cards.push({
                                ...data.result,
                                laneId: 4
                            })
                        }
                    }
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: PUT_TASK, payload: newList })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Tugas Berhasil Diubah' })
                    dispatch({ type: GET_ACTION_TASK, payload: true })
                }
                else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onUpdateStatusTask = (dataTask, id_task, newListData) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        updateStatusTask(dataTask, id_task)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: UPDATE_STATUS_TASK, payload: newListData })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Status Berhasil Diubah' })
                    dispatch({ type: GET_ACTION_TASK, payload: true })
                }
                else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onUpdateStatusKorespondensi = (payload, id_task, newListData) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        updateStatusKorespondensi(payload, id_task)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: UPDATE_STATUS_TASK, payload: newListData })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Status Berhasil Diubah' })
                }
                else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onAddCommentTask = (payload, newDetailTask, setToogleComment = undefined) => {
    const { messages } = appIntl();
    return (dispatch) => {
        // dispatch({ type: FETCH_START })
        addCommentTask(payload)
            .then(data => {
                const newComment = {
                    id: data.result.id,
                    message: data.result.message,
                    creator_avatar: data.result.creator_avatar,
                    creator: data.result.creator,
                    created_at: data.result.created_at,
                    is_creator: data.result.is_creator,
                    child: data.result.child
                };

                const index = newDetailTask.comments.findIndex(item => {
                    return item.id === payload.parent_id
                })

                if (payload.parent_id === '') {
                    newDetailTask.comments.unshift(newComment);
                } else {
                    newDetailTask.comments[index].child.unshift(newComment)
                }

                if (data.success) {
                    // dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: ADD_COMMENT_TM, payload: newDetailTask })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Komentar Berhasil Ditambahkan' })
                    if (setToogleComment) setToogleComment(false);
                } else {
                    dispatch({ type: FETCH_ERROR, payload: messages['message.somethingWentWrong'] })
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
}

export const onDeleteTaskTM = (id, newListData) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        deleteTaskTM(id)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: DELETE_TASK_TM, payload: newListData });
                    dispatch({ type: SHOW_MESSAGE, payload: 'Task Berhasil Dihapus' })
                    dispatch({ type: GET_ACTION_TASK, payload: true })
                } else {
                    dispatch({ type: FETCH_ERROR, payload: messages['message.somethingWentWrong'] })
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}
